<template>
    <div id="reportDailySection">
        <card>
            <Form ref="searchForm" :model="searchForm" inline class="searchForm" id="searchFormSection" @keyup.enter.native="getDate()">
                <Form-item prop="zoneId">
                    <Select v-model="searchForm.zoneId" filterable style="width: 250px" placeholder="全部" clearable>
                        <Option v-for="item in zoneList" :value="item.id" :key="item.id">{{ item.name}}</Option>
                    </Select>
                </Form-item>
                <FormItem prop="daterange">
                    <DatePicker :value="searchForm.daterange" type="daterange" split-panels placeholder="选择时间范围"
                                style="width: 240px"
                                format="yyyy-MM-dd" @on-change="searchForm.daterange=$event"></DatePicker>
                </FormItem>
                <Form-item prop="classId">
                    <Select v-model="searchForm.classId" filterable style="width: 250px" clearable placeholder="选择班级">
                        <Option v-for="item in multiClassList" :value="item.id" :key="item.id">{{ item.name}}</Option>
                    </Select>
                </Form-item>
                <FormItem>
                    <Button type="primary" @click="getData"  size="small" style="margin-right:10px;">搜索</Button>
                    <Button type="primary" @click="exportData"  size="small">导出</Button>
                </FormItem>
            </Form>
            <h3 style="margin:10px 0">应出勤总数：{{plan}}，实际出勤总数：{{actual}}，平均出勤率：{{attendance}}</h3>
            <Table :columns="columns" :data="data">
                <template slot-scope="{ row, index }" slot="attendance">
                    {{getAttendance(row.plan,row.actual)}}
                </template>
            </Table>
        </card>
    </div>
</template>
<script>
  import moment from 'moment';
  import config from '@/config'
  const baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro

  export default {
    name: 'report_attendance',
    data () {
      return {
        plan:0,
        actual:0,
        attendance:0,
        searchForm:{
          daterange: [
            moment(new Date()).subtract(31,"days").format("YYYY-MM-DD"),
            moment(new Date()).subtract(1,"days").format("YYYY-MM-DD")
          ],
          zoneId:this.$store.state.app.zoneList[0].id,
          classId:null
        },
        multiClassList:null,
        columns: [
          {
            title: '序号',
            type: 'index'
          },
          {
            title: '学员',
            key: 'studentName'
          },
          {
            title: '班级',
            key: 'className'
          },
          {
            title: '应出勤',
            key: 'plan'
          },
          {
            title: '实际出勤',
            key: 'actual'
          },
          {
            title: '出勤率',
            slot: 'attendance'
          }
        ],
        data: [],
      }
    },
    computed: {
      zoneList() {
        return this.$store.state.app.zoneList
      },
    },
    methods: {
      getAttendance(plan,actual){
        if (!plan){
          return "-";
        }else{
          return ((actual/plan*100).toFixed(2))+"%" ;
        }
      },
      getData(){
        this.$api.report.attendance({
          startDate:this.searchForm.daterange[0],
          endDate:this.searchForm.daterange[1],
          zoneId:this.searchForm.zoneId,
          classId:this.searchForm.classId,
        }).then(resp => {
          this.data = resp.list;
          this.plan = resp.plan;
          this.actual = resp.actual;
          this.attendance = this.getAttendance(this.plan,this.actual);
        });
      },
      exportData(){
        window.open(baseUrl+"edu/web/report/exportattendance?startDate="
          +this.searchForm.daterange[0]+"&endDate="+this.searchForm.daterange[1]
          +"&zoneId="+this.searchForm.zoneId)
          +this.searchForm.classId?"&classId="+this.searchForm.classId:'';
      },
      getMultiClassList() {
        if (this.multiClassList == null) {
          this.$api.clazz.getAvailableMultiClass().then(resp => {
            if (resp.state == 'ok'){
              this.multiClassList = resp.data;
            }else{
              this.$Message.error(resp.msg)
            }
          });
        }
      },
    },
    mounted: function () {
      this.getMultiClassList();
      this.getData();
    }
  }
</script>
